export const scrollingHeader = () => {
  let lastScrollTop = 0;
  let mobileMenuOpen = false;

  const menuToggle = document.querySelector(
    ".mega-menu-wrap .mega-menu-toggle"
  );

  if (menuToggle) {
    window.addEventListener(
      "scroll",
      function () {
        const currentScroll = window.scrollY || window.pageYOffset;
        const headerEl = document.querySelector(".header-mobile");

        if (menuToggle.classList.contains("mega-menu-open")) {
          mobileMenuOpen = true;
        } else {
          mobileMenuOpen = false;
        }

        if (currentScroll > lastScrollTop && !mobileMenuOpen) {
          // Scrolling down
          headerEl.style.transition = "transform 0.3s";
          headerEl.style.transform = "translateY(-100%)";
        } else {
          // Scrolling up
          headerEl.style.transition = "transform 0.3s";
          headerEl.style.transform = "translateY(0)";
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      },
      false
    );
  }

  // Add crolled class to header
  const headerEl = document.querySelector(".header-menu--desktop");
  if (headerEl) {
    if (window.scrollY > 100) {
      headerEl.classList.add("scrolled");
    } else {
      headerEl.classList.remove("scrolled");
    }
    window.addEventListener("scroll", function () {
      if (window.scrollY > 100) {
        headerEl.classList.add("scrolled");
      } else {
        headerEl.classList.remove("scrolled");
      }
    });
  }


  // Check if product description is in the viewport and add/remove class to sticky line

  const element = document.querySelector('.product-summary');

  if (element) { // Check if the product-summary element exists on the page
    const stickyLine = document.querySelector('.quick-menu-desktop__wrap');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Do something when the element is visible
          stickyLine.classList.remove('visible');
        } else {
          stickyLine.classList.add('visible');
        }
      });
    }, { threshold: [0] });

    observer.observe(element);
  }
};
